import axios from 'axios';
import { normalizePersonDisplayNames } from '../utils/personName.js';

const baseURL = import.meta.env.VITE_API_URL || '/api/messenger';
let accessToken = null;
let refreshPromise = null;
let sessionListener = null;

export const api = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 30_000
});

const refreshClient = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 15_000
});

export function setAccessToken(token) {
  accessToken = token || null;
}

export function getAccessToken() {
  return accessToken;
}

export function onSessionChange(listener) {
  sessionListener = listener;
}

export async function refreshSession() {
  if (!refreshPromise) {
    refreshPromise = refreshClient.post('/auth/refresh', null, { skipAuthRefresh: true })
      .then(({ data }) => {
        normalizePersonDisplayNames(data);
        setAccessToken(data.accessToken);
        sessionListener?.(data);
        return data;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}

api.interceptors.request.use((config) => {
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

api.interceptors.response.use(
  (response) => {
    normalizePersonDisplayNames(response.data);
    return response;
  },
  async (error) => {
    const original = error.config;
    const isUnauthorized = error.response?.status === 401;
    if (!isUnauthorized || original?._retry || original?.skipAuthRefresh) throw error;
    original._retry = true;
    try {
      await refreshSession();
      original.headers.Authorization = `Bearer ${accessToken}`;
      return api(original);
    } catch (refreshError) {
      setAccessToken(null);
      sessionListener?.(null);
      throw refreshError;
    }
  }
);

export function errorMessage(error, fallback = 'Не удалось выполнить действие') {
  if (!navigator.onLine) return 'Нет соединения с интернетом';
  return error?.response?.data?.error?.message || error?.message || fallback;
}

export function uploadUrl(attachmentId) {
  return `${baseURL}/uploads/${attachmentId}`;
}
